import { DefaultButtonBar } from '@/components/button-bar'
import { ContractView } from '@/pages/Contract'

const ResourcesContractView = ({ history, ...props }) => {
  return (
    <>
      <ContractView {...props} noTitle noSubtitle />
      <DefaultButtonBar />
    </>
  )
}

export default ResourcesContractView
